<div class="grid-container margin-top border-bottom-medium-gray">
  <div class="grid-x grid-margin-x">
    <div class="cell large-1 small-1 medium-1 text-align-right">
      <label for="fromDate">From:</label>
    </div>
    <div class="cell small-11 medium-5 large-3 date-picker-cell">
      <common-date-picker [id]="'fromDate'" (dateUpdated)="fromDateChanged($event)" [initialDate]="fromDate"></common-date-picker>
    </div>
    <div class="cell large-1 small-1 medium-1 text-align-right">
      <label for="toDate">To:</label>
    </div>
    <div class="cell small-11 medium-5 large-3 date-picker-cell">
      <common-date-picker [id]="'toDate'" (dateUpdated)="toDateChanged($event)" [initialDate]="toDate"></common-date-picker>
    </div>
    <div class="cell small-6 medium-6 large-2 vertical-align-middle">
      <button (click)="generateReport()" [disabled]="invalidDateCombination" class="button">
        Filter by Date
      </button>
    </div>
  </div>
  <div class="grid-x grid-margin-x">
    <div class="cell small-12 medium-6 large-8">
      &nbsp;
    </div>
    <div class="cell small-12 medium-6 large-4">
      @if (invalidDateCombination) {
        <span class="small-font-size red italic">From Date must be less than To Date</span>
      }
    </div>
  </div>
</div>
<div class="grid-container margin-top">
  <div class="grid-x margin-top">
    <div class="cell small-12 medium-6 large-6">
      <label class="bold">Permits Issued / Denied</label>
      <div class="grid-x margin-top">
        <div class="cell small-12 medium-6 large-6"><span class="bold">From</span> {{ fromDate | date:'MM/dd/yyyy' }}</div>
        <div class="cell small-12 medium-6 large-6"><span class="bold">To</span> {{ toDate | date:'MM/dd/yyyy' }}</div>
      </div>
      <div class="grid-x">
        <div class="cell small-12 medium-6 large-6"><span class="bold">Permits Issued</span></div>
        <div class="cell small-12 medium-6 large-6"><span class="bold">{{ reportData.permitsIssued }}</span></div>
      </div>
      <div class="grid-x">
        <div class="cell small-12 medium-6 large-6"><span class="bold">Permits Denied</span></div>
        <div class="cell small-12 medium-6 large-6"><span class="bold">{{ reportData.permitsDenied }}</span></div>
      </div>
      <div class="grid-x">
        <div class="cell small-12 medium-6 large-6"><span class="bold">Defined Horizontal Permits</span></div>
        <div class="cell small-12 medium-6 large-6"><span class="bold">{{ reportData.permitsDefinedHorizontal}}</span></div>
      </div>
      <div class="grid-x">
        <div class="cell small-12 medium-6 large-6"><span class="bold">Marcellus Shale Permits</span></div>
        <div class="cell small-12 medium-6 large-6"><span class="bold">{{ reportData.permitsMarcellusShale}}</span></div>
      </div>
      <div class="grid-x">
        <div class="cell small-12 medium-6 large-6"><span class="bold">Utica / Point Pleasant Shale Permits</span></div>
        <div class="cell small-12 medium-6 large-6"><span class="bold">{{ reportData.permitsUticaShale}}</span></div>
      </div>
    </div>
    <div class="cell small-12 medium-6 large-6">
      <label class="bold">Permits Issued By Type</label>
      <div class="grid-x margin-top">
        <div class="cell small-12 medium-6 large-6"><span class="bold">From</span> {{ fromDate | date:'MM/dd/yyyy' }}</div>
        <div class="cell small-12 medium-6 large-6"><span class="bold">To</span> {{ toDate | date:'MM/dd/yyyy' }}</div>
      </div>
      <div class="grid-x">
        <div class="cell small-12 medium-6 large-6"><span class="bold">Permits to Drill</span></div>
        <div class="cell small-12 medium-6 large-6"><span class="bold">{{ reportData.permitsToDrill }}</span></div>
      </div>
      <div class="grid-x">
        <div class="cell small-12 medium-6 large-6"><span class="bold">Plug & Abandon</span></div>
        <div class="cell small-12 medium-6 large-6"><span class="bold">{{ reportData.permitsToAbandon }}</span></div>
      </div>
      <div class="grid-x">
        <div class="cell small-12 medium-6 large-6"><span class="bold">Deepen - Horizontal</span></div>
        <div class="cell small-12 medium-6 large-6"><span class="bold">{{ reportData.permitsToDeepenHorizontal }}</span></div>
      </div>
      <div class="grid-x">
        <div class="cell small-12 medium-6 large-6"><span class="bold">Deepen - Vertical</span></div>
        <div class="cell small-12 medium-6 large-6"><span class="bold">{{ reportData.permitsToDeepenVertical }}</span></div>
      </div>
      <div class="grid-x">
        <div class="cell small-12 medium-6 large-6"><span class="bold">Convert</span></div>
        <div class="cell small-12 medium-6 large-6"><span class="bold">{{ reportData.permitsToConvert }}</span></div>
      </div>
      <div class="grid-x">
        <div class="cell small-12 medium-6 large-6"><span class="bold">Plug Back</span></div>
        <div class="cell small-12 medium-6 large-6"><span class="bold">{{ reportData.permitsToPlugBack }}</span></div>
      </div>
      <div class="grid-x">
        <div class="cell small-12 medium-6 large-6"><span class="bold">Revise Location</span></div>
        <div class="cell small-12 medium-6 large-6"><span class="bold">{{ reportData.permitsToReviseLocation }}</span></div>
      </div>
      <div class="grid-x">
        <div class="cell small-12 medium-6 large-6"><span class="bold">Reopen</span></div>
        <div class="cell small-12 medium-6 large-6"><span class="bold">{{ reportData.permitsToReopen }}</span></div>
      </div>
      <div class="grid-x">
        <div class="cell small-12 medium-6 large-6"><span class="bold">Reissue</span></div>
        <div class="cell small-12 medium-6 large-6"><span class="bold">{{ reportData.permitsToReissue }}</span></div>
      </div>
      <div class="grid-x">
        <div class="cell small-12 medium-6 large-6"><span class="bold">Stratigraphic</span></div>
        <div class="cell small-12 medium-6 large-6"><span class="bold">{{ reportData.stratigraphicPermits }}</span></div>
      </div>
      <div class="grid-x">
        <div class="cell small-12 medium-6 large-6"><span class="bold">TOTAL</span></div>
        <div class="cell small-12 medium-6 large-6"><span class="bold">{{ reportData.total }}</span></div>
      </div>
    </div>
  </div>
</div>
<div class="grid-container margin-top">
  <div class="grid-x grid-margin-x">
    <div class="cell small-12 medium-12 large-12 text-right vertical-align-middle">
      <button (click)="downloadReport()" class="button" [disabled]="invalidDateCombination">
        Download Report
      </button>
    </div>
  </div>
  <ag-grid-angular class="data-grid " [gridOptions]="gridOptions" [rowData]="gridReportData" (filterChanged)="onFilterChanged($event)" (firstDataRendered)="resizeColumns()" (paginationChanged)="resizeColumns()" aria-label="Permit Applications Tracking Summary Report"></ag-grid-angular>
</div>
